type SelectOptions = {
	label: string;
	value: any;
}[];

export const FILE_TYPES_OPTIONS: SelectOptions = [
	{ label: 'CSV', value: 'csv' },
	{ label: 'XLSX', value: 'xlsx' },
];
